<template>
	<div class="card">
        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
          	<div class="text-muted fs-19 d-flex justify-content-start">
		   		<strong>Pedidos</strong>
		  	</div>
		  	<bsh-dropdown-nav
		  		id="dropdownPedido"
		  		:tabs="tabs"
		  		:ativo="2"
		  		@navChanged="ChangeChart">
		  	</bsh-dropdown-nav>
        </div>
        <div class="card-body">
			<chart  
				:data="config.data"
				:identify="config.id"
				width="100%"
				height="40"
				:key="chartKey">
			</chart>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados'],
		data(){
			return {
				data: [],
				label: [],
				datasets: [],
				tabs: [
		            {
		              	label: 'Semana',
		              	field: 'semana',
		            },
		            {
		              	label: 'Mês',
		              	field: 'mes'
		            },
		            {
		            	label: 'Ano',
		              	field: 'ano',
		            }
				],
				config: {
					'id': 'chartPedido',
					'width': '100%',
					'data': [] 
				},
				chartKey: 1
			}
		},
		created(){
			this.setLabelAno();
			this.ChangeChart('ano');
		},
		methods: {
			ChangeChart(chartPeriod){
				this.datasets = [];
				if(chartPeriod == 'ano'){
					this.label = this.setLabelAno();
					this.datasets.push(this.dados.total_pedidos_mes_ano);
				}
				if(chartPeriod == 'mes'){
					this.label = this.setLabelMes();
					this.datasets.push(this.dados.total_pedidos_dia_mes);
				}
				if(chartPeriod == 'semana'){
					this.label = this.setLabelSemana();
					this.datasets.push(this.dados.total_pedidos_dia_semana);
				}
				this.setConfigData();
				this.chartKey += 1;
			},
			setLabelMes(){
				var date = new Date();
				var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				var dia_fim = ultimoDia.getDate();
				var result = [];
				for(var i=1; i<=dia_fim; i++){
					result.push(String(i));
				}	
				return result;
			},
			setLabelAno(){
				return [
					'Jan',
					'Fev',
					'Mar',
					'Abr',
					'Mai',
					'Jun',
					'Jul',
					'Ago',
					'Set',
					'Out',
					'Nov',
					'Dez'
				];
			},
			setLabelSemana(){
				return [
					'Dom',
					'Seg',
					'Ter',
					'Qua',
					'Qui',
					'Sex',
					'Sab'
				];
			},
			setConfigData(){
				this.config['data'] = {
				 	type: 'bar',
				  	data: {
				    	labels: this.label,
				    	datasets: this.datasets
				  	},
				  	options: {
				    	scales: {
				      		xAxes: [
				      			{
				        			time: {
				          				unit: 'date'
				        			},
				        			gridLines: {
				          				display: false
				        			},
				        			ticks: {
				          				maxTicksLimit: 32
				        			}
				      			}
				      		],
				      		yAxes: [{
				        		ticks: {
				          			min: 0,
				          			maxTicksLimit: 5
				        		},
				        		gridLines: {
				          			color: "rgba(0, 0, 0, .125)",
				        		}
				      		}],
				    	},
				    	legend: {
				      		display: false
				    	}
				  	}
				}
			}
		}
	}
</script>